import React from 'react';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { TabsOption } from 'global';
import { CustomerDetailsTabs } from 'modules/customers/types';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { CardBackground } from 'components/CardBackground/CardBackground';
import {
  CustomerDetailsCreditAppsTab,
  CustomerDetailsGeneralTab,
  CustomerDetailsDocumentsTab,
  CustomerDetailsActivityHubTab,
} from './tabs';

export const CustomerDetailsPage = () => {
  const tabs: TabsOption<CustomerDetailsTabs>[] = [
    {
      label: 'General',
      value: CustomerDetailsTabs.General,
      component: <CustomerDetailsGeneralTab />,
      urlAnchor: `#${CustomerDetailsTabs.General}`,
      isVisible: true,
    },
    {
      label: 'Activity Hub',
      value: CustomerDetailsTabs.ActivityHub,
      component: <CustomerDetailsActivityHubTab />,
      urlAnchor: `#${CustomerDetailsTabs.ActivityHub}`,
      isVisible: true,
    },
    {
      label: 'Documents',
      value: CustomerDetailsTabs.Documents,
      component: <CustomerDetailsDocumentsTab />,
      urlAnchor: `#${CustomerDetailsTabs.Documents}`,
      isVisible: true,
    },
    {
      label: 'Credit Apps',
      value: CustomerDetailsTabs.CreditApps,
      component: <CustomerDetailsCreditAppsTab />,
      urlAnchor: `#${CustomerDetailsTabs.CreditApps}`,
      isVisible: true,
    },
  ];

  return (
    <PageContainer>
      <TabsContainer<CustomerDetailsTabs>
        tabs={tabs}
        TabsLabelWrapper={CardBackground}
        tabsWrapperProps={{ mb: 1 }}
        isSyncWithAnchor
      />
    </PageContainer>
  );
};
